import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';

import SideMenuItem from './SideMenuItem';

const styles = () => ({
  paper: {
    maxWidth: 'calc( 100vw * 2 / 5)',
    width: '100%',
    '@media(max-width: 571px)': {
      maxWidth: 'calc( 100vw * 2 / 3)',
    },
    borderRight: 'none',
  },
  paperAnchorDockedLeft: {
    width: '252px',
    position: 'relative',
    zIndex: 1,
  },
});

const SideMenuView = ({
  items,
  position,
  open,
  onClose,
  type,
  classes,
  isLogin,
  onLogout,
  userProfile,
  ...restProps
}) => {
  return (
    <Drawer
      anchor={position}
      open={open}
      onClose={onClose}
      variant={type}
      classes={{
        paper: classes.paper,
        paperAnchorDockedLeft: classes.paperAnchorDockedLeft,
      }}
      ModalProps={{
        disablePortal: true,
      }}
      {...restProps}
    >
      {type !== 'permanent' && (
        <SideMenuItem icon={'account_circle'} title={userProfile.displayName} />
      )}
      {items.map(item => (
        <SideMenuItem
          icon={item.icon}
          title={item.title}
          path={item.path}
          key={item.path || item.url}
          onClick={onClose}
          asNavLink
          item={item}
          url={item.url}
        />
      ))}
      {type !== 'permanent' &&
        (isLogin ? (
          <SideMenuItem title={'ออกจากระบบ'} icon={'exit_to_app'} onClick={onLogout} />
        ) : (
          <SideMenuItem title={'เข้าสู่ระบบ'} asNavLink={true} path={'/login'} onClick={onClose} />
        ))}
    </Drawer>
  );
};

SideMenuView.propTypes = {
  items: PropTypes.array,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onItemClick: PropTypes.func,
  type: PropTypes.oneOf(['permanent', 'persistent', 'temporary']),
};

SideMenuView.defaultProps = {
  items: [],
};

export default withStyles(styles)(SideMenuView);
